import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Grid,
    Card,
    CardMedia,
    CircularProgress,
    Container,
} from "@mui/material";

function VisionMission() {
    const [visionmission, setVisionmission] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("/files/corporate/vision_mission.txt")
            .then((res) => {
                setVisionmission(res.data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* --- Main Title --- */}
            <Typography
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mb: { xs: 4, sm: 5, md: 6 },
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem", // mobile
                        sm: "2.2rem", // tablet
                        md: "2.8rem", // laptop
                        lg: "3rem",  // desktop
                    },
                }}
            >
                Vision & Mission
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={5}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    {/* --- Vision Section --- */}
                    <Grid
                        container
                        spacing={4}
                        alignItems="center"
                        sx={{
                            mb: { xs: 4, sm: 5, md: 6 },
                            flexDirection: {
                                xs: "column", // mobile
                                sm: "column", // tablet
                                md: "row",    // laptop & desktop
                            },
                        }}
                    >
                        {/* Vision Text */}
                        <Grid
                            item
                            xs={12}
                            md={7}
                            sx={{
                                width: {
                                    xs: "100%",
                                    sm: "100%",
                                    md: "60%",
                                },
                            }}
                        >
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: "bold",
                                    mb: { xs: 1.5, sm: 2 },
                                    color: "#030366",
                                    fontSize: {
                                        xs: "1.2rem",
                                        sm: "1.4rem",
                                        md: "1.5rem",
                                    },
                                }}
                            >
                                Vision
                            </Typography>
                            {visionmission?.map((data, index) => (
                                <Typography
                                    key={index}
                                    paragraph
                                    sx={{
                                        fontFamily: "Raleway, sans-serif",
                                        textAlign: "justify",
                                        fontSize: {
                                            xs: "0.95rem",
                                            sm: "1rem",
                                            md: "1.1rem",
                                        },
                                        lineHeight: 1.8,
                                    }}
                                >
                                    {data.vision}
                                </Typography>
                            ))}
                        </Grid>

                        {/* Vision Image */}
                        <Grid
                            item
                            xs={12}
                            md={5}
                            sx={{
                                width: {
                                    xs: "100%",
                                    sm: "100%",
                                    md: "30%",
                                },
                                display: "flex",
                                justifyContent: {
                                    xs: "center",
                                    sm: "center",
                                    md: "flex-start",
                                },
                            }}
                        >
                            <Card
                                sx={{
                                    borderRadius: 3,
                                    overflow: "hidden",
                                    boxShadow: 3,
                                    width: "100%",
                                    maxWidth: { md: 400 },
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    alt="Vision"
                                    image="/images/vision1.jpg"
                                    sx={{
                                        height: {
                                            xs: 250,
                                            sm: 300,
                                            md: 350,
                                        },
                                        width: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            </Card>
                        </Grid>
                    </Grid>

                    {/* --- Mission Section --- */}
                    <Grid
                        container
                        spacing={4}
                        alignItems="center"
                        sx={{
                            mb: { xs: 4, sm: 5, md: 6 },
                            flexDirection: {
                                xs: "column", // mobile
                                sm: "column", // tablet
                                md: "row",    // laptop & desktop
                            },
                        }}
                    >
                        {/* Mission Text */}
                        <Grid
                            item
                            xs={12}
                            md={7}
                            sx={{
                                width: {
                                    xs: "100%",
                                    sm: "100%",
                                    md: "60%",
                                },
                            }}
                        >
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: "bold",
                                    mb: { xs: 1.5, sm: 2 },
                                    color: "#030366",
                                    fontSize: {
                                        xs: "1.2rem",
                                        sm: "1.4rem",
                                        md: "1.5rem",
                                    },
                                }}
                            >
                                Mission
                            </Typography>
                            {visionmission?.map((data, index) => (
                                <Typography
                                    key={index}
                                    paragraph
                                    sx={{
                                        fontFamily: "Raleway, sans-serif",
                                        textAlign: "justify",
                                        fontSize: {
                                            xs: "0.95rem",
                                            sm: "1rem",
                                            md: "1.1rem",
                                        },
                                        lineHeight: 1.8,
                                    }}
                                >
                                    {data.mission}
                                </Typography>
                            ))}
                        </Grid>

                        {/* Mission Image */}
                        <Grid
                            item
                            xs={12}
                            md={5}
                            sx={{
                                width: {
                                    xs: "100%",
                                    sm: "100%",
                                    md: "30%",
                                },
                                display: "flex",
                                justifyContent: {
                                    xs: "center",
                                    sm: "center",
                                    md: "flex-start",
                                },
                            }}
                        >
                            <Card
                                sx={{
                                    borderRadius: 3,
                                    overflow: "hidden",
                                    boxShadow: 3,
                                    width: "100%",
                                    maxWidth: { md: 400 },
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    alt="Mission"
                                    image="/images/mission2.jpg"
                                    sx={{
                                        height: {
                                            xs: 250,
                                            sm: 300,
                                            md: 350,
                                        },
                                        width: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            </Card>
                        </Grid>
                    </Grid>
                </>
            )}
        </Container>
    );
}

export default VisionMission;










// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//     Box,
//     Typography,
//     Grid,
//     Card,
//     CardContent,
//     CardMedia,
//     CircularProgress,
//     Container,
// } from "@mui/material";

// function VisionMission() {
//     const [visionmission, setVisionmission] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         axios
//             .get("/files/corporate/vision_mission.txt")
//             .then((res) => {
//                 setVisionmission(res.data);
//                 setLoading(false);
//             })
//             .catch(() => setLoading(false));
//     }, []);

//     return (
//         <Container maxWidth="lg" sx={{ py: 6 }}>
//             <Typography
//                 variant="h3"
//                 align="center"
//                 gutterBottom
//                 sx={{ fontWeight: "bold", color: "#030366", mb: 6, mt: 5 }}
//             >
//                 Vision & Mission
//             </Typography>

//             {loading ? (
//                 <Box display="flex" justifyContent="center" mt={5}>
//                     <CircularProgress />
//                 </Box>
//             ) : (
//                 <>
//                     {/* Vision Section */}
//                     <Grid container spacing={4} alignItems="center" sx={{ mb: 6 }}>
//                         <Grid item xs={12} md={7} sx={{ width: "60%" }}>

//                             <Typography
//                                 variant="h5"
//                                 sx={{ fontWeight: "bold", mb: 2, color: "#030366" }}
//                             >
//                                 Vision
//                             </Typography>
//                             {visionmission &&
//                                 visionmission.map((data, index) => (
//                                     <Typography
//                                         key={index}
//                                         variant="body1"
//                                         paragraph
//                                         sx={{
//                                             fontFamily: "Raleway, sans-serif",
//                                             textAlign: "justify",
//                                             fontSize: "18px",
//                                             lineHeight: 1.8,
//                                         }}
//                                     >
//                                         {data.vision}
//                                     </Typography>
//                                 ))}
//                         </Grid>

//                         <Grid item xs={12} md={5} sx={{ width: "30%" }}>
//                             <Card
//                                 sx={{
//                                     borderRadius: 3,
//                                     overflow: "hidden",
//                                     boxShadow: 3,
//                                 }}
//                             >
//                                 <CardMedia
//                                     component="img"
//                                     alt="Vision"
//                                     height="300"
//                                     image="/images/vision1.jpg"
//                                 />
//                             </Card>
//                         </Grid>
//                     </Grid>

//                     {/* Mission Section */}
//                     <Grid container spacing={4} alignItems="center" sx={{ mb: 6 }}>
//                         <Grid item xs={12} md={7} sx={{ width: "60%" }}>
//                             <Typography
//                                 variant="h5"
//                                 sx={{ fontWeight: "bold", mb: 2, color: "#030366" }}
//                             >
//                                 Mission
//                             </Typography>
//                             {visionmission &&
//                                 visionmission.map((data, index) => (
//                                     <Typography
//                                         key={index}
//                                         variant="body1"
//                                         paragraph
//                                         sx={{
//                                             fontFamily: "Raleway, sans-serif",
//                                             textAlign: "justify",
//                                             fontSize: "18px",
//                                             lineHeight: 1.8,
//                                         }}
//                                     >
//                                         {data.mission}
//                                     </Typography>
//                                 ))}
//                         </Grid>

//                         <Grid item xs={12} md={5} sx={{ width: "30%" }}>
//                             <Card
//                                 sx={{
//                                     borderRadius: 3,
//                                     overflow: "hidden",
//                                     boxShadow: 3,
//                                 }}
//                             >
//                                 <CardMedia
//                                     component="img"
//                                     alt="Mission"
//                                     height="300"
//                                     image="/images/mission2.jpg"
//                                 />
//                             </Card>
//                         </Grid>
//                     </Grid>
//                 </>
//             )}
//         </Container>
//     );
// }

// export default VisionMission;
